export default __webpack_public_path__ + "static/media/P.1052bd77.png";